<template>
  <u-input v-on:input.native="$emit('input', $event.target.value)" :required="required" :autofocus="autofocus" ref="definput" class="erp-input erp-autocomplete float-icon input-hide-loading" color="amber" v-model="model"
           placeholder="" hide-underline v-mask="person.type == 1 ? '###.###.###-##' : '##.###.###/####-##'">
    <sl-loading v-if="loading" content="" class="size-18" />
  </u-input>
</template>

<script>
import {UInput} from "uloc-vue"
import SlLoading from "@/components/layout/components/Loading"

export default {
  name: "DocumentoPessoaInput",
  components: {SlLoading, UInput},
  props: {
    person: {
      required: true
    },
    value: {
      required: true
    },
    debounce: {
      type: Number,
      default: 500
    },
    tipo: {
      type: Number,
      default: 1
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      model: this.value
    }
  },
  watch: {
  },
  computed: {
  },
  methods: {
  }
}
</script>
